const SYSTEM_PREFIX = /^\d+_\d+_/;

export function hasSystemPrefix(name: string): boolean {
  return SYSTEM_PREFIX.test(name);
}

export function stripSystemPrefix(name: string): string {
  return name.replace(SYSTEM_PREFIX, '');
}

export function getSystemPrefix(name: string): string {
  return name.match(SYSTEM_PREFIX)?.[0] ?? '';
}
